module.exports = __webpack_public_path__ + "media/images/native-home-39b92b54a218a092c156c1c5d2e4a7ea.svg";